// extracted by mini-css-extract-plugin
export default {"container":"company-logo_container__tBG9s","image":"company-logo_image__7tJnm","abbreviation":"company-logo_abbreviation__9EK+q"};